export default __webpack_public_path__ + "static/ForgetSectionLeft_es-27dcee1ddf84366ca2dcb78d0901d592.png";